import get from 'lodash/get'
import at from 'lodash/at'
import {
  fetchCollection,
  performActionOnResource,
  baseRequest,
} from './index'

import { contractSchema } from '../schemas'
import { setCurrentContractFilterForLocation } from './work-tracker-filters'
import FileSaver from 'file-saver'

export const CONTRACTS_REQUEST = 'CONTRACTS_REQUEST'
export const CONTRACTS_SUCCESS = 'CONTRACTS_SUCCESS'
export const CONTRACTS_FAILURE = 'CONTRACTS_FAILURE'

export function fetchContractsForLocation (locationId) {
  return (dispatch, getState) => {
    return dispatch(fetchCollection({
      url: `/locations/${locationId}/contracts`,
      key: 'contracts',
      schema: contractSchema,
      actions: [ CONTRACTS_REQUEST, CONTRACTS_SUCCESS, CONTRACTS_FAILURE ],
      responseInterceptor: response => ({ ...response, locationId })
    }))
      .then(() => {
        dispatch(setCurrentContractFilterForLocation(locationId))
      })
  }
}

export const ENQUEUE_CONTRACT_EXPORT_REQUEST = 'ENQUEUE_CONTRACT_EXPORT_REQUEST'
export const ENQUEUE_CONTRACT_EXPORT_SUCCESS = 'ENQUEUE_CONTRACT_EXPORT_SUCCESS'
export const ENQUEUE_CONTRACT_EXPORT_FAILURE = 'ENQUEUE_CONTRACT_EXPORT_FAILURE'

export function enqueueExport (contractId, endpoint, options) {
  return performActionOnResource({
    url: `/contracts/${contractId}`,
    key: 'contracts',
    action: endpoint,
    actions: [ ENQUEUE_CONTRACT_EXPORT_REQUEST, ENQUEUE_CONTRACT_EXPORT_SUCCESS, ENQUEUE_CONTRACT_EXPORT_FAILURE ],
    actionPayload: { contractId },
    ...options,
  })
}

export const DOWNLOAD_CONTRACT_REQUEST = 'DOWNLOAD_CONTRACT_REQUEST'
export const DOWNLOAD_CONTRACT_SUCCESS = 'DOWNLOAD_CONTRACT_SUCCESS'
export const DOWNLOAD_CONTRACT_FAILURE = 'DOWNLOAD_CONTRACT_FAILURE'

export function downloadCSV(contractId, endpoint = 'contract_csv', rest) {
  return baseRequest({
    url: `/contracts/${contractId}/${endpoint}`,
    method: 'GET',
    actions: [ DOWNLOAD_CONTRACT_REQUEST, DOWNLOAD_CONTRACT_SUCCESS, DOWNLOAD_CONTRACT_FAILURE ],
    responseInterceptor: (data, response) => {
      let file = new File([data.result], data.filename, { type: 'text/csv' })
      FileSaver.saveAs(file)
    },
    ...rest
  })
}

export function requestWorkTrackerReport(locationId, contractId) {
  return (dispatch, getState) => {
    const query = queryParams(getState, locationId)
    return dispatch(
      enqueueExport(contractId, 'work_tracker_report', { query })
    )
  }
}

export function downloadWorkTrackerSingleServiceReport(locationId, contractId) {
  return (dispatch, getState) => {
    const query = queryParams(getState, locationId)
    return dispatch(
      downloadCSV(contractId, 'work_tracker_single_service_report', { query, method: 'post' })
    )
  }
}

const queryParams = (getState, locationId) => {
  let {
    contractId,
    areaTypeId,
    subLocationId,
    datePeriod: { startPeriod, endPeriod } = {},
    lastCleaned,
    serviceId,
    amountIds,
    sortingId,
  } = get(getState(), `workTrackerFilters.${locationId}`, {})

  if (startPeriod) { startPeriod = startPeriod.toISOString() }
  if (endPeriod) { endPeriod = endPeriod.toISOString() }

  return {
    contractId,
    areaTypeId,
    subLocationId,
    serviceId,
    amountIds,
    sortingId,
    startPeriod,
    endPeriod,
    lastCleaned
  }
}



// WEBPACK FOOTER //
// ./src/actions/contracts.js